module.exports = __webpack_public_path__ + "static/media/md.9b4d5658.svg";